import { render, staticRenderFns } from "./ModalIndication.vue?vue&type=template&id=a6d4b756&scoped=true&lang=pug"
import script from "./ModalIndication.vue?vue&type=script&lang=js"
export * from "./ModalIndication.vue?vue&type=script&lang=js"
import style0 from "./ModalIndication.vue?vue&type=style&index=0&id=a6d4b756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d4b756",
  null
  
)

export default component.exports